'use client';

import React, { useContext } from 'react';
import { useI18n } from 'next-localization';

import { useOasApp } from '@/providers/oas-app-provider';
import { UserDataContext } from '@/providers/user-data-provider';

export const SearchBarBottom = (): JSX.Element => {
  const fields = useOasApp();
  const { t } = useI18n();
  const user = useContext(UserDataContext);

  return (
    <>
      {fields.isMho && user && (
        <div className="row col-lg-12 mt-3">
          <p
            className="m-0"
            dangerouslySetInnerHTML={{
              __html: t('OAS.LandingPage.PreferredFacilityMessage', {
                facility: `<b>${user?.facility?.facilityName}</b>`,
              }),
            }}
          ></p>
        </div>
      )}
    </>
  );
};
